import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { SideBar, PageNotFound } from '@pipltrust/apps-components';
import { connect } from 'react-redux';
import { AppActions } from 'Redux/modules/app/actions';
import Billing from '../Pages/Billing';
import Organization from '../Pages/OrganizationPage';
import Profile from '../Pages/ProfilePage';
import ManageUsers from '../Pages/ManageUsers/ManageUsers';
import Usage from '../Pages/UsageAnalytics/containers/Usage';
import styles from './ManagementPanel.module.less';
import { AppSelectors } from '../Redux/modules/app/selectors';
import { SIDE_BAR_TABS, GROUPS } from './constants';
import { getDifferentPrefixToPath } from './utils';

const ManagementPanel = (props) => {
  const currentTabPath = useLocation().pathname;
  const getActiveTab = () => {
    const activeTab = Object.values(SIDE_BAR_TABS).find((tab) => {
      return currentTabPath.includes(tab.path) || tab.path.includes(currentTabPath);
    });
    return activeTab ? activeTab.name : '';
  };
  const [activeTab, setActiveTab] = useState(getActiveTab());
  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [window.location.pathname]);

  const shouldDisplaySideBar = activeTab !== SIDE_BAR_TABS.PROFILE.name && props.isOrgAdmin;
  const hasApiContext = window.location.pathname.includes('/api');
  const shouldRedirectFromApi = hasApiContext && !props.allowedApi;
  const shouldRefreshPage = !hasApiContext && GROUPS.find((group) => group.title === 'API reports');

  if (shouldRedirectFromApi) {
    const newUrl = window.location.pathname.replace('/api', '');
    return <Redirect to={newUrl} />;
  }
  if (shouldRefreshPage) {
    window.location.reload();
  }

  return (
    <div className={[styles.headerSpace, props.hasBanner ? styles.bannerSpace : null].join(' ')}>
      <div className={styles.section}>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.sideBar}>
              {shouldDisplaySideBar && (
                <SideBar
                  groups={GROUPS}
                  activeTab={activeTab}
                  navigateToTab={setActiveTab}
                  currentApp="accounts"
                  user={props.user}
                  eventTrackingFunction={props.eventTrackingFunction}
                />
              )}
            </div>
            <div className={[styles.route, !shouldDisplaySideBar ? styles.noSidebarRoute : ''].join(' ')}>
              {props.isOrgAdmin ? (
                <Switch>
                  <Route path={getDifferentPrefixToPath('/billing')} component={Billing} />
                  <Route path={getDifferentPrefixToPath('/manage-users')} component={ManageUsers} />
                  <Route path={getDifferentPrefixToPath('/usage')} component={Usage} />
                  <Route path={getDifferentPrefixToPath('/organization')} component={Organization} />
                  <Route path={getDifferentPrefixToPath('/profile')} component={Profile} />
                  <Redirect path={getDifferentPrefixToPath('/')} exact to="/manage-users/users/" />
                  <Route path={getDifferentPrefixToPath('/*')} component={PageNotFound} />
                </Switch>
              ) : (
                <Switch>
                  <Route path={getDifferentPrefixToPath('/profile')} component={Profile} />
                  <Redirect path={getDifferentPrefixToPath('/')} exact to="/profile/" />
                  <Route path={getDifferentPrefixToPath('/*')} component={PageNotFound} />
                </Switch>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ManagementPanel.propTypes = {
  hasBanner: PropTypes.bool,
  isOrgAdmin: PropTypes.bool,
  allowedApi: PropTypes.bool,
  user: PropTypes.object,
  eventTrackingFunction: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    hasBanner: AppSelectors.hasBannerSelector(state),
    isOrgAdmin: AppSelectors.isOrgAdminSelector(state),
    allowedApi: AppSelectors.allowedApiSelector(state),
    user: AppSelectors.userSelector(state),
  };
};

const mapDispatchToProp = {
  eventTrackingFunction: AppActions.eventTracking,
};

export default connect(mapStateToProps, mapDispatchToProp)(ManagementPanel);
